import { httpPost, httpGet } from '../../../../utils/api.utils';
import { actions } from 'react-redux-form';
import { batch } from 'react-redux';
import Moment from 'moment';
import { convertDateStringToDateFormat } from "../../../../utils/helpers.utils";

import {
    getActiveVendors
    , setBillingAccountError
    , getAccountType
    , getAccountStatus
    , getAccountFirstBill
    , getAllocationLevel
    , getAccountInterval
    , getAllAddressLocation1
    , getAllAddressLocation2
    , setDataByVendor
    , billingAccountModel
    , locationModel
    , getAccountPurchaseOrder
    , setDefaultState
    , fetchBillingAccountDetails
    , getMasterAccountId
    , setLocationLoading
    , getContractCodes
    , getAPVendors
    , resetExistingContractData
    , resetExistingApVendorData
} from "../../../../constants/model-reducers/external/finance/billing-account-details.settings"

const defaultState = () => (
    {
        isLoaded: false
        , activeVendors: []
        , isError: false
        , accountTypes: []
        , accountStatus: []
        , accountFirstBill: []
        , accountLevel: []
        , accounInterval: []
        , financeContractByVendor: []
        , masterAccountByVendor: []
        , apVendorsByVendor: []
        , allAddressLocation1: []
        , allAddressLocation2: []
        , accountPurchaseOrder: []
        , locationPage1: 1
        , locationPage2: 1
        , hasMoreLocation1: true
        , hasMoreLocation2: true
        , isLocationLoading: false

        , hasMoreActiveVendors: false
        , activeVendorsPage: 1

        , hasMoreContractCodes: false
        , ContractCodePage: 1

        , hasMoreAPVendors: false
        , APVendorsPage: 1

        , vendorDataID: null
    }
);

const initialState = defaultState();

export const billingAccountInitalState = billingAccountModel;
export const billingAddressInitialState = locationModel;
export const remitAddressInitialState = locationModel;

export const BillingAccountAction = {
    getBillingAccountDetailsForm: (financeAccountId, page = 1, pageSize = 15) => async (dispatch) => {
        var result = await httpGet(`external/finance/getBillingAccountDetails/${financeAccountId ?? 0}`);

        if (result != null) {
            batch(() => {
                dispatch(actions.load('billingAccountForm.billingAccount.vendorName', result.billingAccountDetails?.Vendor));
                dispatch(actions.load('billingAccountForm.billingAccount.vendorDetailId', result.billingAccountDetails.VendorDetailId));
                dispatch(actions.load('billingAccountForm.billingAccount.accountTypeId', result.billingAccountDetails.AccountTypeId));
                dispatch(actions.load('billingAccountForm.billingAccount.billingAccountNumber', result.billingAccountDetails.AccountNumber));
                dispatch(actions.load('billingAccountForm.billingAccount.masterAccountId', result.billingAccountDetails.MasterAccountNumberId));
                dispatch(actions.load('billingAccountForm.billingAccount.accountStatusId', result.billingAccountDetails.AccountStatusId));
                dispatch(actions.load('billingAccountForm.billingAccount.currency', result.billingAccountDetails.Currency));
                dispatch(actions.load('billingAccountForm.billingAccount.financeContractId', result.billingAccountDetails.ContractID));
                dispatch(actions.load('billingAccountForm.billingAccount.invoiceFormat', result.billingAccountDetails.InvoiceFormat));
                dispatch(actions.load('billingAccountForm.billingAccount.invoiceReceiptDate', convertDateStringToDateFormat(result.billingAccountDetails.ExpectedInvoiceReceiptDate, false)));
                dispatch(actions.load('billingAccountForm.billingAccount.accountIntervalId', result.billingAccountDetails.InvoiceIntervalId));
                dispatch(actions.load('billingAccountForm.billingAccount.accountFirstBillId', result.billingAccountDetails.FirstBillReviewId));
                dispatch(actions.load('billingAccountForm.billingAccount.allocationLevelId', result.billingAccountDetails.AllocationLevelId));
                dispatch(actions.load('billingAccountForm.billingAccount.apVendorId', result.billingAccountDetails.APVendorID));
                dispatch(actions.load('billingAccountForm.billingAccount.remitId', result.billingAccountDetails.RemitID));
                dispatch(actions.load('billingAccountForm.billingAccount.requesterName', result.billingAccountDetails.RequesterName));
                dispatch(actions.load('billingAccountForm.billingAccount.clientName', result.billingAccountDetails.ClientName));
                dispatch(actions.load('billingAccountForm.billingAccount.takeOverdate', convertDateStringToDateFormat(result.billingAccountDetails.TakeOverDate, false)));
                dispatch(actions.load('billingAccountForm.billingAccount.descriptions', result.billingAccountDetails.Description));

                //Billing Address
                dispatch(actions.load(`billingAccountForm.billingAddress.locationID`, result.billingAccountDetails.billingAddress.LocationSiteID));
                dispatch(actions.load(`billingAccountForm.billingAddress.address1`, result.billingAccountDetails.billingAddress.Address1));
                dispatch(actions.load(`billingAccountForm.billingAddress.address2`, result.billingAccountDetails.billingAddress.Address2));
                dispatch(actions.load(`billingAccountForm.billingAddress.locationType`, result.billingAccountDetails.billingAddress.LocationType));
                dispatch(actions.load(`billingAccountForm.billingAddress.locationCity`, result.billingAccountDetails.billingAddress.City));
                dispatch(actions.load(`billingAccountForm.billingAddress.locationState`, result.billingAccountDetails.billingAddress.State));
                dispatch(actions.load(`billingAccountForm.billingAddress.locationCountry`, result.billingAccountDetails.billingAddress.Country));
                dispatch(actions.load(`billingAccountForm.billingAddress.locationZip`, result.billingAccountDetails.billingAddress.ZIP));
                dispatch(actions.load(`billingAccountForm.billingAddress.demarcLocation`, result.billingAccountDetails.billingAddress.DemarcLocation));
                //Remit Address
                dispatch(actions.load(`billingAccountForm.remitAddress.locationID`, result.billingAccountDetails.remitAddress.LocationSiteID));
                dispatch(actions.load(`billingAccountForm.remitAddress.address1`, result.billingAccountDetails.remitAddress.Address1));
                dispatch(actions.load(`billingAccountForm.remitAddress.address2`, result.billingAccountDetails.remitAddress.Address2));
                dispatch(actions.load(`billingAccountForm.remitAddress.locationType`, result.billingAccountDetails.remitAddress.LocationType));
                dispatch(actions.load(`billingAccountForm.remitAddress.locationCity`, result.billingAccountDetails.remitAddress.City));
                dispatch(actions.load(`billingAccountForm.remitAddress.locationState`, result.billingAccountDetails.remitAddress.State));
                dispatch(actions.load(`billingAccountForm.remitAddress.locationCountry`, result.billingAccountDetails.remitAddress.Country));
                dispatch(actions.load(`billingAccountForm.remitAddress.locationZip`, result.billingAccountDetails.remitAddress.ZIP));
                dispatch(actions.load(`billingAccountForm.remitAddress.demarcLocation`, result.billingAccountDetails.remitAddress.DemarcLocation));
            })

            var vendorId = result.billingAccountDetails.VendorDetailId;
            var getFinanceContractByVendor = await httpGet(`external/finance/getFinanceContractByVendor/${vendorId}/${page}/${pageSize}`)
            var getAllMasterAccountsByVendor = await httpGet(`external/finance/getAllMasterAccountsByVendor/${vendorId}`)
            var getApVendorsByVendor = await httpGet(`external/finance/getApVendorsByVendor/${vendorId}/${page}/${pageSize}`)

            var selectedContractId = getFinanceContractByVendor.data.find(c => c.FinanceContractId === result.billingAccountDetails.ContractID);

            if (selectedContractId) {
                dispatch(actions.load('billingAccountForm.billingAccount.serviceTypeName', selectedContractId.ContractServiceTypeName));
            }

            if (result.billingAccountDetails.MasterAccountNumberId === null) {
                dispatch({
                    type: getMasterAccountId                    
                    , masterAccountByVendor: getAllMasterAccountsByVendor
                });
            }
        }
        dispatch({
            type: fetchBillingAccountDetails
            , financeContractByVendor: getFinanceContractByVendor.data
            , masterAccountByVendor: getAllMasterAccountsByVendor
            , apVendorsByVendor: getApVendorsByVendor.data
            , data: false
            , vendorDataID: vendorId
        });

        return result.billingAccountDetails?.Vendor;   
    },


    fetchFinanceContractbyVendor: (page = 1, searchString = '', newVendorId = 0) => async (dispatch, State) => {
        const pageSize = 15;

        if (page === 1) {
            dispatch({
                type: resetExistingContractData,
                payload: []
            })
        }

        var existingContract = State().billingAccountDetails.financeContractByVendor;
        var vendorId = State().billingAccountDetails.vendorDataID;
        var selectedVendorId = newVendorId != 0 ? newVendorId : vendorId;
        var url = `external/finance/getFinanceContractByVendor/${selectedVendorId}/${page}/${pageSize}`;

        if (searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        var res = await httpGet(url);

        if (res != null) {
            const combinedContract = searchString ? res.data : [...existingContract, ...res.data];
            const uniqueContractMap = new Map(combinedContract.map(contract => [contract.FinanceContractId, contract]));
            const contract = Array.from(uniqueContractMap.values());
            dispatch({
                type: getContractCodes
                , getFinanceContractByVendor: contract
                , isLoaded: true
                , isError: false
                , hasMore: res.hasMoreData
            });
        } else {
            dispatch({
                type: setBillingAccountError
                , isLoaded: false
                , isError: true
            });
        }
    },

    fetchAPVendorsbyVendor: (page = 1, searchString = '', newVendorId = 0) => async (dispatch, State) => {
        const pageSize = 15;

        if (page === 1) {
            dispatch({
                type: resetExistingApVendorData,
                payload: []
            })
        }

        var existingAPVendors = State().billingAccountDetails.apVendorsByVendor;
        var vendorId = State().billingAccountDetails.vendorDataID;
        var selectedVendorId = newVendorId != 0 ? newVendorId : vendorId;
        var url = `external/finance/getApVendorsByVendor/${selectedVendorId}/${page}/${pageSize}`;

        if (searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }

        var res = await httpGet(url);
        if (res != null) {
            const combinedVendors = searchString ? res.data : [...existingAPVendors, ...res.data];
            const uniqueVendorsMap = new Map(combinedVendors.map(vendor => [vendor.Key, vendor]));
            const apVendors = Array.from(uniqueVendorsMap.values());
            dispatch({
                type: getAPVendors
                , getApVendorsByVendor: apVendors
                , isLoaded: true
                , isError: false
                , hasMore: res.hasMoreData
            });
        } else {
            dispatch({
                type: setBillingAccountError
                , isLoaded: false
                , isError: true
            });
        }
    },

    saveBillingAccount: (financeAccountId, validate, costAllocationData, purchaseOrderData) => async (dispatch, state) => {
        const { billingAddress, remitAddress, billingAccount } = state().form.billingAccountForm

        var costAllocation = costAllocationData.length > 0 ? costAllocationData : [];
        var purchaseOrder = purchaseOrderData.length > 0 ? purchaseOrderData : [];

        const convertTypeCostAllocation = costAllocation.map((item) => ({
            CompanyCode: parseInt(item.CompanyCode)
            , CostAllocationID: parseInt(item.CostAllocationID)
            , CostCodeID: parseInt(item.CostCodeID)
            , CostCodePercent: parseFloat(item.CostCodePercent)
            , GLCode: item.GLCode
            , GLCodeID: parseInt(item.GLCodeID)
            , LastModified: item.LastModified
        }));

        const convertTypePurchaseOrder = purchaseOrder.map((item) => ({
            AccountPurchaseOrderID: item.Key
            , PONumber: item.PONumber
            , POValue: parseFloat(item.POValue)
            , ValidFrom: item.ValidDateFrom ? Moment(item.ValidDateFrom).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
            , ValidTo: item.ValidDateTo ? Moment(item.ValidDateTo).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
            , LastModified: item.LastModified
        }));

        try {
            var detailsForm = {
                VendorDetailId: billingAccount.vendorDetailId
                , AccountTypeId: parseInt(billingAccount.accountTypeId)
                , AccountNumber: billingAccount.billingAccountNumber
                , MasterAccountNumberId: parseInt(billingAccount.masterAccountId)
                , AccountStatusId: parseInt(billingAccount.accountStatusId)
                , ContractID: parseInt(billingAccount.financeContractId)
                , InvoiceFormat: billingAccount.invoiceFormat
                , ExpectedInvoiceReceiptDate: billingAccount.invoiceReceiptDate ? Moment(billingAccount.invoiceReceiptDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
                , InvoiceIntervalId: parseInt(billingAccount.accountIntervalId)
                , FirstBillReviewId: parseInt(billingAccount.accountFirstBillId)
                , AllocationLevelId: parseInt(billingAccount.allocationLevelId)
                , APVendorID: parseInt(billingAccount.apVendorId)
                , RemitID: billingAccount.remitId
                , RequesterName: billingAccount.requesterName
                , ClientName: billingAccount.clientName
                , TakeOverDate: billingAccount.takeOverdate ? Moment(billingAccount.takeOverdate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
                , Description: billingAccount.descriptions
            }

            var billingLocation = {
                ...billingAddress
                , LocationSiteID: billingAddress.locationID ? parseInt(billingAddress.locationID) : null
                , DemarcLocation: billingAddress.demarcLocation
            }

            var remitLocation = {
                ...remitAddress
                , LocationSiteID: remitAddress.locationID ? parseInt(remitAddress.locationID) : null
                , DemarcLocation: remitAddress.demarcLocation
            }

            var formData = {
                ...detailsForm
                , billingAddress: {
                    ...billingLocation
                }
                , remitAddress: {
                    ...remitLocation
                }
                , costAllocation: convertTypeCostAllocation
                , purchaseOrder: convertTypePurchaseOrder

            }

            var result = await httpPost(`external/finance/saveBillingAccount/${financeAccountId}/${validate}`, formData)

            dispatch(actions.resetErrors('billingAccountForm'));
        }
        catch (e) {
            return e
        }

        if (result.success == false) {
            if (result.propertyName == "costAllocation") {
                dispatch(actions.setErrors("billingAccountForm.financeCostAllocation", true));
            }
        } else {
            if (result.data?.billingAccount) {
                const cleanBillingAccount = {
                    ...result.data.billingAccount,
                    serviceTypeName: null,   // force reset
                    contractCode: null       // if needed
                };
                // Use server response as baseline
                dispatch(actions.load("billingAccountForm.billingAccount", cleanBillingAccount));
            }
        }

        return result;
    },

    selectLocation: (model, locationID) => (dispatch, state) => {
        const { allAddressLocation1, allAddressLocation2 } = state().billingAccountDetails;

        let newLocationAddress;
        if (model.includes("billingAddress")) {
            newLocationAddress = allAddressLocation1.find(r => r.LocationId == locationID);
        } else {
            newLocationAddress = allAddressLocation2.find(r => r.LocationId == locationID);

        }

        dispatch(actions.change(model, locationID));

        var modelName = model.includes("billingAddress") ? "billingAddress" : (model.includes("remitAddress") ? "remitAddress" : "");

        if (modelName != "" && newLocationAddress) {
            dispatch(actions.change(`billingAccountForm.${modelName}.address1`, newLocationAddress.LocationAddress1));
            dispatch(actions.change(`billingAccountForm.${modelName}.address2`, newLocationAddress.LocationAddress2));
            dispatch(actions.change(`billingAccountForm.${modelName}.locationType`, newLocationAddress.LocationType));
            dispatch(actions.change(`billingAccountForm.${modelName}.locationCity`, newLocationAddress.LocationCity));
            dispatch(actions.change(`billingAccountForm.${modelName}.locationState`, newLocationAddress.LocationState));
            dispatch(actions.change(`billingAccountForm.${modelName}.locationCountry`, newLocationAddress.CountryName));
            dispatch(actions.change(`billingAccountForm.${modelName}.locationZip`, newLocationAddress.LocationZip));
        }
        else {
            dispatch(actions.reset(`billingAccountForm.${modelName}.address1`));
            dispatch(actions.reset(`billingAccountForm.${modelName}.address2`));
            dispatch(actions.reset(`billingAccountForm.${modelName}.locationType`));
            dispatch(actions.reset(`billingAccountForm.${modelName}.locationCity`));
            dispatch(actions.reset(`billingAccountForm.${modelName}.locationState`));
            dispatch(actions.reset(`billingAccountForm.${modelName}.locationCountry`));
            dispatch(actions.reset(`billingAccountForm.${modelName}.locationZip`));
        }
    },

    selectVendorId: (vendorId) => async (dispatch, state) => {
        const { activeVendors } = state().billingAccountDetails;
        const page = 1;
        const pageSize = 15;

        var selectedVendor = activeVendors.find(v => (v.VendorDetailId === vendorId || v.VendorName === vendorId));

        dispatch(actions.change(vendorId));

        if (selectedVendor) {
            dispatch(actions.change(`billingAccountForm.billingAccount.vendorDetailId`, vendorId))
            dispatch(actions.change(`billingAccountForm.billingAccount.vendorName`, selectedVendor.VendorName));
            dispatch(actions.change(`billingAccountForm.billingAccount.currency`, selectedVendor.CurrencyName));
        }
        else {
            dispatch(actions.reset(`billingAccountForm.billingAccount.vendorDetailId`))
            dispatch(actions.reset(`billingAccountForm.billingAccount.vendorName`));
            dispatch(actions.reset(`billingAccountForm.billingAccount.currency`));
        }

        var getFinanceContractByVendor = await httpGet(`external/finance/getFinanceContractByVendor/${selectedVendor.VendorDetailId}/${page}/${pageSize}`)
        var getAllMasterAccountsByVendor = await httpGet(`external/finance/getAllMasterAccountsByVendor/${selectedVendor.VendorDetailId}`)
        var getApVendorsByVendor = await httpGet(`external/finance/getApVendorsByVendor/${selectedVendor.VendorDetailId}/${page}/${pageSize}`)

        if (getFinanceContractByVendor || getAllMasterAccountsByVendor || getApVendorsByVendor) {
            dispatch({
                type: setDataByVendor
                , financeContractByVendor: getFinanceContractByVendor.data
                , masterAccountByVendor: getAllMasterAccountsByVendor
                , apVendorsByVendor: getApVendorsByVendor.data
                , vendorId: vendorId
                , isLoaded: true
                , isError: false
            });
        } else {
            dispatch({
                type: setBillingAccountError
                , isLoaded: false
                , isError: true
                , financeContractByVendor: []
                , masterAccountByVendor: []
                , apVendorsByVendor: []
            })
        }
    },

    selectedContractId: (financeContractId) => async (dispatch, state) => {
        const { financeContractByVendor } = state().billingAccountDetails;

        var selectedContractId = financeContractByVendor.find(c => c.FinanceContractId === financeContractId)

        dispatch(actions.change(financeContractId));

        if (selectedContractId) {
            dispatch(actions.change(`billingAccountForm.billingAccount.financeContractId`, financeContractId))
            dispatch(actions.change(`billingAccountForm.billingAccount.contractCode`, selectedContractId.ContractCode));
            dispatch(actions.change(`billingAccountForm.billingAccount.serviceTypeName`, selectedContractId.ContractServiceTypeName));
        }
    },

    selectedApVendor: (apVendorId) => async (dispatch, state) => {
        const { apVendorsByVendor } = state().billingAccountDetails;

        var selectedApVendorId = Object.values(apVendorsByVendor).find(v => v.Key === apVendorId)
        if (selectedApVendorId) {
            dispatch(actions.change(`billingAccountForm.billingAccount.apVendorId`, apVendorId))
            dispatch(actions.change(`billingAccountForm.billingAccount.apVendor`, selectedApVendorId.Value));
        }
    },

    getActiveVendors: (page = 1, searchString = '') => async (dispatch, State) => {
        const pageSize = 15;

        var existingVendor = State().billingAccountDetails.activeVendors;

        var url = `external/finance/getAllActiveVendors/${page}/${pageSize}`;

        if (searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }

        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getActiveVendors
                , activeVendors: page > 1 ? [...existingVendor, ...res.data] : res.data
                , isLoaded: true
                , isError: false
                , hasMore: res.hasMoreData
                , activeVendorsPage: page
            });
        } else {
            dispatch({
                type: setBillingAccountError
                , isLoaded: false
                , isError: true
            });
        }
    },

    getAccountType: () => async (dispatch) => {
        var res = await httpGet('external/finance/getAccountTypes')

        if (res != null) {
            dispatch({
                type: getAccountType
                , accountTypes: res
                , isLoaded: true
                , isError: false
            });
        } else {
            dispatch({
                type: setBillingAccountError
                , isLoaded: false
                , isError: true
            })
        }
    },

    getAccountStatus: () => async (dispatch) => {
        var res = await httpGet('external/finance/getAccountStatuses')

        if (res != null) {
            dispatch({
                type: getAccountStatus
                , accountStatus: res
                , isLoaded: true
                , isError: false
            });
        } else {
            dispatch({
                type: setBillingAccountError
                , isLoaded: false
                , isError: true
            })
        }
    },

    getAccountFirstBill: () => async (dispatch) => {
        var res = await httpGet('external/finance/getFinanceAccountFirstBill')

        if (res != null) {
            dispatch({
                type: getAccountFirstBill
                , accountFirstBill: res
                , isLoaded: true
                , isError: false
            });
        } else {
            dispatch({
                type: setBillingAccountError
                , isLoaded: false
                , isError: true
            })
        }
    },

    getAllocationLevel: () => async (dispatch) => {
        var res = await httpGet('external/finance/getAllocationLevels')

        if (res != null) {
            dispatch({
                type: getAllocationLevel
                , accountLevel: res
                , isLoaded: true
                , isError: false
            });
        } else {
            dispatch({
                type: setBillingAccountError
                , isLoaded: false
                , isError: true
            })
        }
    },

    getAccountInterval: () => async (dispatch) => {
        var res = await httpGet('external/finance/getAccountInterval')

        if (res != null) {
            dispatch({
                type: getAccountInterval
                , accounInterval: res
                , isLoaded: true
                , isError: false
            });
        } else {
            dispatch({
                type: setBillingAccountError
                , isLoaded: false
                , isError: true
            })
        }
    },

    getAllAddressLocation1: (page = 1, searchString = '') => async (dispatch) => {
        const pageSize = 15;

        let url = `external/inventory/getAllLocationsWithDropdownList/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }
        var res = await httpGet(url);
        dispatch({
            type: setLocationLoading,
            payload: true
        });
        try {
            if (res != null) {
                dispatch({
                    type: getAllAddressLocation1,
                    payload: {
                        locations1: res,
                        locationPage1: page,
                    }
                });
                dispatch({
                    type: setLocationLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setLocationLoading,
                    payload: false
                });
                dispatch({
                    type: setBillingAccountError
                    , isLoaded: false
                    , isError: true
                })
            }
        } catch (error) {
            return null
        } finally {
            dispatch({
                type: setLocationLoading,
                payload: false
            });
        }
    },

    getAllAddressLocation2: (page = 1, searchString = '') => async (dispatch) => {
        const pageSize = 15;

        let url = `external/inventory/getAllLocationsWithDropdownList/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }
        var res = await httpGet(url);
        dispatch({
            type: setLocationLoading,
            payload: true
        });
        try {
            if (res != null) {
                dispatch({
                    type: getAllAddressLocation2,
                    payload: {
                        locations2: res,
                        locationPage2: page
                    }
                });
                dispatch({
                    type: setLocationLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setLocationLoading,
                    payload: false
                });
                dispatch({
                    type: setBillingAccountError
                    , isLoaded: false
                    , isError: true
                })
            }
        } catch (error) {
            return null
        } finally {
            dispatch({
                type: setLocationLoading,
                payload: false
            });
        }
    },

    getAccountPurchaseOrder: (financeId = 0) => async (dispatch) => {
        var res = await httpGet("external/finance/getAddPurchaseOrder?financeAccountID=" + financeId);
        if (res != null) {

            dispatch({
                type: getAccountPurchaseOrder
                , accountPurchaseOrder: res
                , isError: false
            });
            return res;
        } else {
            dispatch({
                type: setBillingAccountError,
                isError: true
            })
        }
    },

    resetVendorField: (vendorId) => async (dispatch) => {
        dispatch(actions.reset(`billingAccountForm.billingAccount.financeContractId`));
        dispatch(actions.reset(`billingAccountForm.billingAccount.contractCode`));
        dispatch(actions.reset(`billingAccountForm.billingAccount.serviceTypeName`));
        dispatch(actions.reset(`billingAccountForm.billingAccount.apVendorId`));

        if (!vendorId) {
            dispatch(actions.reset(`billingAccountForm.billingAccount.currency`));
        }

        dispatch({
            type: setDefaultState
            , isLoaded: false
            , isError: true
            , financeContractByVendor: []
            , masterAccountByVendor: []
            , apVendorsByVendor: []
        })
    },

    resetBillingAddress: (model) => (dispatch) => {
        var modelName = model.includes("billingAddress") ? "billingAddress" : (model.includes("remitAddress") ? "remitAddress" : "");

        dispatch(actions.reset(`billingAccountForm.${modelName}.address1`));
        dispatch(actions.reset(`billingAccountForm.${modelName}.address2`));
        dispatch(actions.reset(`billingAccountForm.${modelName}.locationType`));
        dispatch(actions.reset(`billingAccountForm.${modelName}.locationCity`));
        dispatch(actions.reset(`billingAccountForm.${modelName}.locationState`));
        dispatch(actions.reset(`billingAccountForm.${modelName}.locationCountry`));
        dispatch(actions.reset(`billingAccountForm.${modelName}.locationZip`));
    },

    resetContractField: () => async (dispatch) => {
        dispatch(actions.reset(`billingAccountForm.billingAccount.serviceTypeName`));
    },

    resetBillingAccountForm: () => (dispatch) => {
        dispatch(actions.reset('billingAccountForm'))
        dispatch(actions.reset('billingAccountForm.billingAccount'))
    }
}

export const reducer = (state, action) => {
    state = state || initialState
    switch (action.type) {
        case getActiveVendors:
            return {
                ...state,
                activeVendors: action.activeVendors,
                hasMoreActiveVendors: action.hasMore,
                activeVendorsPage: action.activeVendorsPage
            }
        case getContractCodes:
            return {
                ...state,
                financeContractByVendor: action.getFinanceContractByVendor,
                hasMoreContractCodes: action.hasMore
            }
        case getAPVendors:
            return {
                ...state,
                apVendorsByVendor: action.getApVendorsByVendor,
                hasMoreAPVendors: action.hasMore,

            }
        case getAccountType:
            return {
                ...state,
                accountTypes: action.accountTypes
            }
        case getAccountStatus:
            return {
                ...state,
                accountStatus: action.accountStatus
            }
        case getAccountFirstBill:
            return {
                ...state,
                accountFirstBill: action.accountFirstBill
            }
        case getAllocationLevel:
            return {
                ...state,
                accountLevel: action.accountLevel
            }
        case getAccountInterval:
            return {
                ...state,
                accounInterval: action.accounInterval
            }
        case getAllAddressLocation1: {
            const { locations1, locationPage1 } = action.payload;
            const newLocations = Array.isArray(locations1) ? locations1 : [];
            let finalList;

            if (locationPage1 === 1) {
                finalList = newLocations;
            } else {
                const combinedList = [...state.allAddressLocation1, ...newLocations];
                const uniqueList = Array.from(new Map(combinedList.map(item => [item.LocationId, item])).values());
                finalList = uniqueList;
            }

            return {
                ...state,
                allAddressLocation1: finalList,
                hasMoreLocation1: newLocations.length > 0,
                locationPage1: locationPage1
            };
        }
        case getAllAddressLocation2: {
            const { locations2, locationPage2 } = action.payload;
            const newLocations = Array.isArray(locations2) ? locations2 : [];
            let finalList;

            if (locationPage2 === 1) {
                finalList = newLocations;
            } else {
                const combinedList = [...state.allAddressLocation2, ...newLocations];
                const uniqueList = Array.from(new Map(combinedList.map(item => [item.LocationId, item])).values());
                finalList = uniqueList;
            }

            return {
                ...state,
                allAddressLocation2: finalList,
                hasMoreLocation2: newLocations.length > 0,
                locationPage2: locationPage2
            };
        }
        case setLocationLoading:
            return {
                ...state,
                isLocationLoading: action.payload
            }
        case setDataByVendor:
            return {
                ...state,
                financeContractByVendor: action.financeContractByVendor
                , masterAccountByVendor: action.masterAccountByVendor
                , apVendorsByVendor: action.apVendorsByVendor
                , vendorDataID: action.vendorId
            }
        case getAccountPurchaseOrder:
            return {
                ...state,
                accountPurchaseOrder: action.accountPurchaseOrder
            }
        case resetExistingContractData:
            return {
                ...state,
                financeContractByVendor: action.payload
            }
        case resetExistingApVendorData:
            return {
                ...state,
                apVendorsByVendor: action.payload
            }
        case setDefaultState:
            return {
                ...state,
                financeContractByVendor: action.financeContractByVendor
                , masterAccountByVendor: action.masterAccountByVendor
                , apVendorsByVendor: action.apVendorsByVendor
            }
        case getMasterAccountId: {
            return {
                ...state,
                masterAccountByVendor: action.masterAccountByVendor
            }
        }
        case fetchBillingAccountDetails:
            return {
                ...state,
                billingAccountDetailsData: action.data
                , financeContractByVendor: action.financeContractByVendor
                , masterAccountByVendor: action.masterAccountByVendor
                , apVendorsByVendor: action.apVendorsByVendor
                , vendorDataID: action.vendorDataID
            };
        default:
            return state;
    }
}